import './style.scss';
import Form from './form.js';

export default Form;